import React from 'react';
export function App() {
  return <div className="font-sans text-gray-800 bg-gray-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ResearchSection data-id="element-2" />
      <VideoSection data-id="element-3" />
      <TestimonialsSection data-id="element-4" />
      <MediaSection data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}
const HeroSection = () => {
  return <section className="bg-blue-900 py-8 sm:py-10 md:py-12 px-4 text-white" data-id="element-7">
      <div className="container mx-auto max-w-6xl flex flex-col md:flex-row items-center" data-id="element-8">
        <div className="w-full md:w-3/5 pr-0 md:pr-8" data-id="element-9">
          <h2 className="text-lg sm:text-xl md:text-2xl font-medium mb-2" data-id="element-10">
            Top Anti-Aging Doctor:
          </h2>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mb-4 md:mb-6" data-id="element-11">
            New{' '}
            <span className="text-yellow-400" data-id="element-12">Skin "Tightening" Formula</span>{' '}
            Eliminates Saggy Jowls & Neck For Good...
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl mb-6 leading-snug" data-id="element-13">
            No Surgery. No Prescriptions. No Doctors. Research From Yale
            University Proves It Works in Just 7 Days!
          </p>
        </div>
        <div className="w-full md:w-2/5 mt-6 md:mt-0" data-id="element-14">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mrq6CFTukHJ4N1rVz9PWSV/94ab33bb-banner-ba_10ow0dm000000000000000.jpg" alt="Before and After treatment" className="w-full rounded-lg shadow-lg" data-id="element-15" />
        </div>
      </div>
    </section>;
};
const ResearchSection = () => {
  return <section className="py-8 sm:py-10 px-4 bg-white" data-id="element-16">
      <div className="container mx-auto max-w-5xl" data-id="element-17">
        <div className="text-center mb-8 sm:mb-10" data-id="element-18">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-blue-800 mb-3 md:mb-4 px-2" data-id="element-19">
            Backed by Research from Yale, Johns Hopkins, University of London
            and more...
          </h2>
        </div>
        <div className="flex flex-col md:flex-row items-center" data-id="element-20">
          {/* Image div - hidden initially on mobile, shown normally on desktop */}
          <div className="w-full md:w-2/5 hidden md:block" data-id="element-21">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qVJkknu58Ns391zctoVmht/SCS-Dr-Mark-Rosenberg.png" alt="Dr. Mark Rosenberg" className="w-full max-w-md mx-auto" data-id="element-22" />
          </div>
          <div className="w-full md:w-3/5 md:pl-8" data-id="element-23">
            <div className="mb-6" data-id="element-24">
              <p className="text-base sm:text-lg mb-3 sm:mb-4" data-id="element-25">
                For years, the cosmetic industry has led us to believe that
                restoring a firm, youthful neck and lifting saggy jowls after
                menopause requires costly and invasive procedures.
              </p>
              <p className="text-base sm:text-lg mb-3 sm:mb-4" data-id="element-26">
                But Longevity Expert of 30 years, Dr. Mark Rosenberg, exposes
                the real truth:
              </p>
              <p className="text-base sm:text-lg mb-3 sm:mb-4 font-bold" data-id="element-27">
                Lifting Saggy Jowls & Drooping Neck (at home) has never been
                easier.
              </p>
              <p className="text-base sm:text-lg mb-3 sm:mb-4" data-id="element-28">
                "I've explored every remedy imaginable," Dr. Rosenberg shared.
                "Most products on the market today are scams, barely making a
                difference."
              </p>
              <p className="text-base sm:text-lg mb-6 sm:mb-8" data-id="element-29">
                Frustrated with ineffective options,{' '}
                <b data-id="element-30">Dr. Rosenberg developed his own solution</b>, set to
                revolutionize the cosmetic industry.
              </p>
            </div>
            {/* Mobile image - shown only on mobile, right after the text about revolutionizing the industry */}
            <div className="w-full mb-6 md:hidden" data-id="element-31">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qVJkknu58Ns391zctoVmht/SCS-Dr-Mark-Rosenberg.png" alt="Dr. Mark Rosenberg" className="w-full max-w-md mx-auto" data-id="element-32" />
            </div>
            <div className="text-base sm:text-lg space-y-3 sm:space-y-4" data-id="element-33">
              <p data-id="element-34">
                The result? A highly potent & effective solution his patients
                are claiming to be "better than Botox" yet "cheaper than a cup
                of coffee".
              </p>
              <p data-id="element-35">
                "Our clinical trials show it's{' '}
                
                  the only at-home solution for lifting saggy jowls and
                  tightening the neck
                , <span className="font-bold" data-id="element-36"> 
                WITHOUT the hefty price tag or painful procedures
                </span>," Dr.
                Rosenberg told reporters.
              </p>
              <p data-id="element-37">
                In light of his discovery, Dr. Rosenberg released a{' '}
                <b data-id="element-38">short video</b> to demonstrate its results and explain how to
                use his solution correctly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const VideoSection = () => {
  return <section className="py-8 sm:py-10 md:py-12 px-4 bg-blue-900 text-white" data-id="element-39">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-40">
        <div className="mb-6 sm:mb-8" data-id="element-41">
          <p className="text-lg sm:text-xl mb-4 sm:mb-6 px-2" data-id="element-42">
            See how this discovery can transform your appearance (in just days)
          </p>
        </div>
        <div className="bg-white rounded-lg overflow-hidden mb-6 sm:mb-8 shadow-xl" data-id="element-43">
          <div className="relative" data-id="element-44">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mrq6CFTukHJ4N1rVz9PWSV/94ab33bb-banner-ba_10ow0dm000000000000000.jpg" alt="Before and After comparison" className="w-full" data-id="element-45" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-46">
              <a href="https://trk.skatrk02.com/click?" className="bg-blue-500 rounded-full w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center cursor-pointer hover:bg-blue-600 transition-colors" data-id="element-47">
                <svg className="w-8 h-8 sm:w-10 sm:h-10 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-48">
                  <path d="M8 5v10l8-5-8-5z" data-id="element-49"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <a href="https://trk.skatrk02.com/click?" className="bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg text-lg sm:text-xl md:text-2xl transition duration-300 shadow-lg inline-block w-full sm:w-auto" data-id="element-50">
          Yes, I Want to Tighten My Neck & Jowls
        </a>
      </div>
    </section>;
};
const TestimonialsSection = () => {
  return <section className="py-8 sm:py-10 px-4 bg-white" data-id="element-51">
      <div className="container mx-auto max-w-4xl" data-id="element-52">
        <div className="text-center mb-6 sm:mb-8" data-id="element-53">
          <h2 className="text-2xl sm:text-3xl font-bold text-blue-800 px-2" data-id="element-54">
            Real People, Real Results
          </h2>
        </div>
        <div className="space-y-3 sm:space-y-4" data-id="element-55">
          {[{
          name: 'Suzie Frost',
          image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80',
          comment: "This stuff WORKS!!! And you can't beat the price!! I'm 55 years old and seeing results after just 2 weeks!",
          likes: 247,
          time: '11 min'
        }, {
          name: 'Rachel Courtney',
          image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80',
          comment: 'And does it really work for neck lines too?',
          time: '16 min'
        }, {
          name: 'Martha Richardson',
          image: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80',
          comment: 'Yes! it is working for me. My neck lines are almost gone and my jawline is so much tighter!',
          likes: 67,
          time: '14 min',
          isReply: true,
          replyTo: 'Rachel Courtney'
        }, {
          name: 'Jocelyn Phillips',
          image: 'https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80',
          comment: "I saw results in 3 days of use at night and am. The price is great compared to other options I've tried.",
          likes: 108,
          time: '16 min'
        }, {
          name: 'Nancy Miller',
          image: 'https://images.unsplash.com/photo-1546967191-fdfb13ed6b1e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80',
          comment: 'same. my jaws stopped sagging in about 2 weeks. I look years younger!',
          likes: 47,
          time: '14 min',
          isReply: true,
          replyTo: 'Jocelyn Phillips'
        }].map((comment, index) => <div key={index} className={`bg-white rounded-md p-3 sm:p-4 shadow-sm border border-gray-200 ${comment.isReply ? 'ml-12' : ''}`} data-id="element-56">
              <div className="flex" data-id="element-57">
                <img src={comment.image} alt={comment.name} className="w-10 h-10 rounded-full mr-3 object-cover" data-id="element-58" />
                <div className="flex-1" data-id="element-59">
                  <div className="font-semibold text-[#385898]" data-id="element-60">
                    {comment.name}
                  </div>
                  <p className="text-gray-900 text-sm sm:text-base" data-id="element-61">
                    {comment.replyTo && <span className="text-[#385898] mr-1 font-medium" data-id="element-62">
                        {comment.replyTo}
                      </span>}
                    {comment.comment}
                  </p>
                  <div className="flex items-center mt-2 text-[#606770] text-xs" data-id="element-63">
                    <span className="font-semibold hover:underline cursor-pointer" data-id="element-64">
                      Like
                    </span>
                    <span className="mx-1" data-id="element-65">·</span>
                    <span className="font-semibold hover:underline cursor-pointer" data-id="element-66">
                      Reply
                    </span>
                    <span className="mx-1" data-id="element-67">·</span>
                    <span data-id="element-68">{comment.time}</span>
                    {comment.likes && <div className="ml-auto flex items-center" data-id="element-69">
                        <div className="bg-[#1877f2] text-white rounded-full w-4 h-4 flex items-center justify-center mr-1" data-id="element-70">
                          <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 16 16" data-id="element-71">
                            <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" data-id="element-72" />
                          </svg>
                        </div>
                        <span data-id="element-73">{comment.likes}</span>
                      </div>}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-6 sm:mt-8 text-center" data-id="element-74">
          <a href="https://trk.skatrk02.com/click?" className="bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold py-3 px-6 sm:px-8 rounded-lg text-lg sm:text-xl inline-block transition duration-300 shadow-md w-full sm:w-auto" data-id="element-75">
            Watch The Video & Learn More
          </a>
        </div>
      </div>
    </section>;
};
const MediaSection = () => {
  return <section className="py-6 sm:py-8 px-4 bg-white border-t" data-id="element-76">
      <div className="container mx-auto max-w-4xl" data-id="element-77">
        <div className="text-center mb-4 sm:mb-6" data-id="element-78">
          <p className="text-gray-600 font-medium" data-id="element-79">As Seen On:</p>
        </div>
        <div className="flex flex-wrap justify-center items-center" data-id="element-80">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1RAPnd7eX25hbSQjGdVMtm/logos-mob.jpg" alt="Media logos" className="w-full max-w-3xl" data-id="element-81" />
        </div>
      </div>
    </section>;
};
const Footer = () => {
  return <footer className="bg-gray-800 text-white py-6 sm:py-8 px-4 text-sm mt-12 sm:mt-16" data-id="element-82">
      <div className="container mx-auto max-w-4xl" data-id="element-83">
        <div className="text-center mb-4 sm:mb-6 uppercase text-xs sm:text-sm px-2" data-id="element-84">
          <p data-id="element-85">
            THIS IS AN ADVERTORIAL AND NOT AN ACTUAL ARTICLE, BLOG, OR CONSUMER
            PROTECTION UPDATE.
          </p>
        </div>
        <div className="mb-4 sm:mb-6 px-2" data-id="element-86">
          <h3 className="mb-2 text-sm sm:text-base" data-id="element-87">DISCLAIMER</h3>
          <p className="text-gray-300 text-xs leading-relaxed" data-id="element-88">
            This website is not intended to provide medical advice or to take
            the place of medical advice and treatment from your personal
            physician. Visitors are advised to consult their own doctors or
            other qualified health professional regarding the treatment of
            medical conditions. The author shall not be held liable or
            responsible for any misunderstanding or misuse of the information
            contained on this site or for any loss, damage, or injury caused, or
            alleged to be caused, directly or indirectly by any treatment,
            action, or application of any food or food source discussed in this
            website. The U.S. Food and Drug Administration have not evaluated
            the statements on this website. Any trademarks contained herein are
            property of their respective owners. We do our best to keep the
            information on this page up to date but rules and regulations change
            frequently: As such, we cannot be held liable for inaccuracies.
            Thank you for visiting.
          </p>
        </div>
      </div>
    </footer>;
};